<!-- START Travel insurance form -->

<form class="sidebar__form" [formGroup]="form">
	
	<h2 class="pax-title-h2">{{ 'bookingDetails.label.travelInsurance' | ibeadmin:'sync' }}</h2>
	<p class="muted bottom-gap">
		{{ 'bookingDetails.text.chubbInsuranceText' | ibeadmin:'sync' }}
	</p>
	
	<div class="form--edit-mode">
		<div class="form-field--row grid no-padding">
			
			<div class="form-field col-6 col-tp-6 col-p-12">
				<label class="label" for="travel-insurance--vat_number">
					{{ 'bookingDetails.label.insurance.vatNumber' | ibeadmin:'sync' }}
				</label>
				<input Address
					class="input-text"
					formControlName="vatNumber" 
					id="travel-insurance--vat_number" />
				<span 
					aria-live="polite" 
					class="input-error" 
					role="alert"
					[attr.aria-label]="formTravelInsuranceErrors('vatNumber') | ibeadmin:'sync'"
					*ngIf="form.controls['vatNumber'].invalid && displayValidationMessages">
					{{ formTravelInsuranceErrors('vatNumber') | ibeadmin:'sync' }}
				</span>
			</div>
			
			<div class="form-field col-12 col-tp-12 col-p-12" *ngIf="!isITMarket && insuranceFormShow.address_info">
				<label class="label" for="travel-insurance--address">
					{{ 'bookingDetails.label.insurance.address' | ibeadmin:'sync' }}
				</label>
				<input 
					class="input-text"
					formControlName="address" 
					id="travel-insurance--address" />
				<span 
					aria-live="polite" 
					class="input-error" 
					role="alert"
					[attr.aria-label]="formTravelInsuranceErrors('address') | ibeadmin:'sync'"
					*ngIf="form.controls['address'].invalid && displayValidationMessages">
					{{ formTravelInsuranceErrors('address') | ibeadmin:'sync' }}
				</span>
			</div>
			
			<div class="form-field col-4 col-tp-4 col-p-12" *ngIf="!isITMarket && insuranceFormShow.address_info">
				<label class="label" for="main-info--contact_zip_code">
					{{ 'bookingDetails.label.insurance.zipcode' | ibeadmin:'sync' }}
				</label>
				<input 
					class="input-text"
					formControlName="zipcode" 
					placeholder="Insert zip-code"
					id="main-info--contact_zip_code" />
				<span 
					aria-live="polite" 
					class="input-error" 
					role="alert"
					[attr.aria-label]="formTravelInsuranceErrors('zipcode') | ibeadmin:'sync'"
					*ngIf="form.controls['zipcode'].invalid && displayValidationMessages">
					{{ formTravelInsuranceErrors('zipcode') | ibeadmin:'sync' }}
				</span>
			</div>
			
			<div class="form-field col-8 col-tp-8 col-p-12" *ngIf="!isITMarket && insuranceFormShow.address_info">
				<label class="label" for="main-info--contact_city">
					{{ 'bookingDetails.label.insurance.city' | ibeadmin:'sync' }}
				</label>
				<input 
					class="input-text"
					formControlName="city" 
					placeholder="Insert city"
					id="main-info--contact_city" />
				<span 
					aria-live="polite" 
					class="input-error" 
					role="alert"
					[attr.aria-label]="formTravelInsuranceErrors('city') | ibeadmin:'sync'"
					*ngIf="form.controls['city'].invalid && displayValidationMessages">
					{{ formTravelInsuranceErrors('city') | ibeadmin:'sync' }}
				</span>
			</div>
			
		</div>
		
		<hr class="separator">
	</div>
</form>	
		
<!-- END Travel insurance form -->